export default __webpack_public_path__ + "static/media/rocks-04.f0eb1b16.png";